// Quais cartões de canal aparecem na criação de caixa e quais ficam apagados.
//
// Duas camadas: a instalação diz quais canais existem para ela (CHANNELS_ALLOWLIST, lista vazia
// mantém todos) e o plano da conta diz quais ela pode usar (`settings.canais_liberados`, montado
// pelo contrato da agência). Canal do universo que o plano não libera aparece apagado, para o
// cliente saber que existe e pedir; conta sem a lista não tem restrição.
export const parseAllowlist = raw =>
  (raw || '')
    .split(',')
    .map(name => name.trim().toLowerCase())
    .filter(Boolean);

export const channelsForPlan = (channels, allowlistRaw, liberados) => {
  const allowlist = parseAllowlist(allowlistRaw);
  const universo = allowlist.length
    ? channels.filter(channel => allowlist.includes(channel.key))
    : channels;

  if (!Array.isArray(liberados)) return universo;

  return universo.map(channel =>
    liberados.includes(channel.key) ? channel : { ...channel, outOfPlan: true }
  );
};
